import React, { useEffect } from 'react'
import { shortenSido } from '../utils/address'
import Gap from './Gap'
import { setAppStatusBarDark } from '../utils/flutterStatusBar'
import { useSheetDragDismiss } from '../hooks/useSheetDragDismiss'

interface PreviewPlaceBottomSheetProps {
  isOpen: boolean
  onClose: () => void
  placeName: string
  placeAddress: string
}

const PreviewPlaceBottomSheet: React.FC<PreviewPlaceBottomSheetProps> = ({
  isOpen,
  onClose,
  placeName,
  placeAddress,
}) => {
  useEffect(() => {
    setAppStatusBarDark(isOpen)
    return () => setAppStatusBarDark(false)
  }, [isOpen])

  const { handleProps, sheetStyle } = useSheetDragDismiss({
    onClose,
    enabled: isOpen,
  })

  if (!isOpen) {
    return null
  }

  return (
    <>
      <div
        className="fixed inset-0 bg-black bg-opacity-40 z-[1050]"
        onClick={onClose}
      />

      <div className="fixed inset-0 z-[1050] flex items-end justify-center pointer-events-none">
        <div
          className={`
            app-container
            bg-ivoryKey
            rounded-t-30px
            flex
            flex-col
            overflow-hidden
            pointer-events-auto
          `}
          style={sheetStyle}
          onClick={(e) => e.stopPropagation()}
        >
          <div
            className="w-full flex justify-center pt-16px pb-8px"
            {...handleProps}
          >
            <div className="w-40px h-4px bg-472410-20% rounded-full" />
          </div>

          <div className="px-24px pb-32px">
            <p
              className={`
                font-pretendard
                font-700
                text-18px
                leading-125%
                text-brown-80%-main
                text-left
              `}
            >
              {placeName}
            </p>

            {placeAddress.trim() !== '' && (
              <>
                <Gap height={12} />
                <p
                  className={`
                    font-pretendard
                    font-regular
                    text-14px
                    leading-20px
                    text-textColorText2
                    text-left
                    break-words
                  `}
                >
                  {shortenSido(placeAddress)}
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default PreviewPlaceBottomSheet
